import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";
import Img from 'gatsby-image';

import maeshPrototypeVideo from '../../images/Maesh_PayNow_Prototype.mp4';

import MaeshSteps from './maesh-steps';
import ComparisonSlider from './comparison-slider';
import CodeSample from './code-sample';

import { PrimaryButtonLink } from '../styled-components/maesh-buttons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { config } from '@fortawesome/fontawesome-svg-core';


import './landing.css'

config.autoAddCss = false

class Landing extends Component {

	constructor(props){
		super(props);
		this.state = {
			showModal: false
		}
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	componentDidMount() {
        const script = document.createElement('script');
		script.src = 'https://js.hsforms.net/forms/shell.js';
		script.defer = true;
		document.body.appendChild(script);
		script.addEventListener('load', () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: "6856311",
                    formId: "76c37199-3b2b-4f42-859e-3849df055ca7",
                    target: '#hubspotForm'
                });
            }
        });
	}

	openModal(){
		this.setState({showModal: true})
		document.body.classList.add('modal-open');
	}

	closeModal(){
		document.body.classList.remove('modal-open');
		this.setState({ showModal: false });
	}
	
	modalOnShow(){
		window.hbspt.forms.create({
			portalId: "6856311",
			formId: "76c37199-3b2b-4f42-859e-3849df055ca7",
			target: '#hubspotForm'
		});
	}

    render() {
      return (
		  <StaticQuery
		  
		  query={
			graphql`
			  query {
				sgIcon: file(relativePath: { eq: "sg-icon.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				payNowLogo: file(relativePath: { eq: "PayNow.png" }) {
					childImageSharp {
						inline: fixed(width: 80) {
							...GatsbyImageSharpFixed_noBase64
						},
						block: fixed(width: 100) {
							...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				qrCode: file(relativePath: { eq: "qr-code.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				prestashopLogo: file(relativePath: { eq: "prestashop.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				woocommerceLogo: file(relativePath: { eq: "woocommerce.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				reactLogo: file(relativePath: { eq: "react.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				jsLogo: file(relativePath: { eq: "js.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				jsPaddedLogo: file(relativePath: { eq: "js-padded.png" }) {
					childImageSharp {
						fluid(maxWidth: 300, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				compoundCoffee: file(relativePath: { eq: "compound_coffee.png" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				binjaiBrew: file(relativePath: { eq: "binjaibrew.jpg" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
				goPasar: file(relativePath: { eq: "gopasar.jpg" }) {
					childImageSharp {
						fluid(maxWidth: 500, quality: 100) {
						...GatsbyImageSharpFluid
						}
					}
				},
			}`
		  }

		  render={data=>(
			<div>
				<header className="section header">
				<div className="shape-wrapper lead hidden-sm-down">
						<div className="shape shape-background shape-main"></div>
						<div className="shape shape-background shape-top"></div>
				</div>
				<div className="container">
					<div className="row align-items-center first-section">
						<div className="col-md-6 col-lg-7">
							<div>
								<h5 className="font-lg mb-2 text-left">
									The online PayNow payment gateway in Singapore 
									<Img className="inline-emoji" fluid={data.sgIcon.childImageSharp.fluid} alt="SG Flag Icon" />
								</h5>
								<div className="lead valueprop text-left">
									Secure, cheap and easy - Maesh lets your customers pay with 
									<a href="https://www.abs.org.sg/consumer-banking/pay-now" rel="noreferrer" target="_blank">
										<Img loading="eager" fixed={data.payNowLogo.childImageSharp.inline} alt="PayNow" className="d-inline-block align-middle paynow-logo-inline"/>
									</a>
									<br/>
									Accept online payments in minutes for just <span className="price-landing">0.7% + S$0.25</span> per transaction
								</div>
							</div>
							<div className="mt-5 mb-3 align-items-center ">
								<div className="container landing">								
									{
										this.state.showModal ?
										<div class="modal-backdrop show"></div>
										:
										""
									}

									<div className="modal" id="signUp" style={{display: this.state.showModal? 'block':'none'}}>
										<div className="modal-dialog modal-dialog-centered">
											<div className="modal-content">
												<div className="modal-header">
													<h4 className="modal-title">Get lower transaction fees <span role="img" aria-label="stonks"> 📉 </span> </h4>
													<button type="button" className="close" onClick={this.closeModal}>&times;</button>
												</div>
												<div className="modal-body">
													<div className="modal-instructions">
														We'd love to work with you! Leave your details here and
														we'll get back to you ASAP.
													</div>
													<div id="hubspotForm"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-4 ml-lg-auto" id="maesh-demo">
							<div className="screen">
								<div className="prototype-video-container">
									<video id="prototype-video" height="500"  autoPlay muted loop>
										<source src={maeshPrototypeVideo} alt="Maesh Mobile Redirect - PayNow Payment Gateway Singapore"
											type="video/mp4" />
									</video>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
			<section id="conversion-rate" className="section">
				<div className="container text-center">
					<div className="row">
						<div className="col-md-12 col-lg-5 container-conversion-rates" >
							<div className="">
								<h1 className="instruction-header">
									Secure + Easy = Better Conversion Rates
								</h1>
								<p className="instruction-text">
									Maesh uses PayNow and its bank-grade security to receive payments from your customers. And since we use bank apps, not credit cards, you can worry much less about fraud.						</p>
								<p className="instruction-text">
									Plus, our user friendly payments interface also boosts conversion rates!						
								</p>
								<p className="instruction-text">
									<a href="https://maesh.io/docs">Get better conversion rates now  &nbsp; <FontAwesomeIcon style={{fontSize:'1rem'}} icon={faAngleRight} />  </a>
								</p>
							</div>
						</div>
						<div className="col-md-12 col-lg-7">
							<MaeshSteps/>
						</div>
					</div>
				</div>
		
			</section>
			<section id="fees">
				<div className="shape-wrapper2">
					<div className="shape shape-background shape-main gradient gradient-53 square-border-shape-background">
						<div className="container pricing-emphasis-section">
							<div className="section-heading text-center mx-auto">
								<h2 className="color-1">No set-up or monthly fees. Just 0.7% + S$0.25 per transaction.</h2>
								<h3 className="color-1 lead">No, that's not a typo</h3>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section id="comparison">
				<div className="container">
					<div className="row">
						<div id="comparison-slider-container" className="col-md-12 col-lg-7 order-md-2 order-lg-1 d-flex">
							<ComparisonSlider/>
						</div>
						<div className="col-md-12 col-lg-5 order-md-1 order-lg-2 d-flex">
							<div className="flex-align-self-center">
								<h1 className="comparison-header">
									Better margins with Maesh
								</h1>
								<p  className="instruction-text">
									Maesh helps you cut transaction fees by <b>~70%</b>, so you can get more out of every sale you make.
								</p>
								<p className="instruction-text">
									And you only pay when you make a sale with Maesh. No monthly fees, setup fees, or any other unpleasant surprises.	
								</p>
								<p className="instruction-text">
									Already using PayNow? Maesh will automate these payments for you so you can focus on more important things!
								</p>
								<p className="instruction-text">
									<a href="https://maesh.io/docs">Start saving here  &nbsp; <FontAwesomeIcon style={{fontSize:'1rem'}} icon={faAngleRight} />  </a>
								</p>
							</div>
						</div>
					</div>
				</div>
		
			</section>
		
			<section id="integration">
				<div className="container">
					<h1 className="instruction-header text-center">
						Easy Integration
					</h1>
					<div className="row">
						<div className="col-md-12 col-lg-12 d-flex">
							<div className="row flex-align-self-center mx-auto justify-content-center">
								<div className="col-md-12 col-lg-9 d-flex flex-justify-content-center ">
									<a href="https://www.npmjs.com/package/maesh-test" target="_blank" rel="noreferrer">
										<Img fluid={data.reactLogo.childImageSharp.fluid} alt="Maesh React Component" className="platform-icon small-only" />
									</a>
									<a href="./docs/js-cdn" target="_blank">
										<Img fluid={data.jsLogo.childImageSharp.fluid} alt="Maesh.js Library" className="platform-icon small-only" />
									</a>
									<CodeSample/>
								</div>
								<div className="col-md-12 col-lg-3 d-flex justify-content-center flex-column" id="ecommerce-stores">
									<a href="./docs/woocommerce" target="_blank"><Img fluid={data.woocommerceLogo.childImageSharp.fluid} alt="Woocommerce Maesh" className="platform-icon" /></a>
									<a href="./docs/prestashop" target="_blank"><Img fluid={data.prestashopLogo.childImageSharp.fluid} alt="Prestashop Maesh" className="platform-icon" /></a>
								</div>
							</div>
						</div>
						<div className="col-md-12 col-lg-12 easy-integration">
							<div className="out-of-box">
								<p className="integration-text">
									Maesh works right out of the box with WooCommerce, PrestaShop and bespoke codebases, and can work side by side with your other payment methods for a hassle-free integration.
		
									Just plug it in and start saving!	
								</p>
								<br/>
								<p className="integration-text">
									<a href="https://maesh.io/docs">Learn how here &nbsp; <FontAwesomeIcon style={{fontSize:'1rem'}} icon={faAngleRight} />  </a>
								</p>
							</div>
						</div>
					</div>
				</div>
		
			</section>
		
			<section id="merchants">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<h1 className="instruction-header">
								We have over 60 merchants in the Maesh family.
							</h1>
							<h2>This is what they are saying:</h2>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4 col-lg-4 col-sm-12 testimonial">
							<p className="font-regular">
									"Maesh is a great option for reducing your transaction
								costs and they provide tremendous, fast support. Highly recommended to all
								e-commerce stores.”
							</p>
							<div className="testimonial-author">
								<div className="testimonial-name">
									<p>
										<b>
											Kenneth Ong
										</b> <br/>
										Chief Alchemist at <a href="https://compoundcoffee.com/" target="_blank" rel="noreferrer">Compound Coffee Co.</a>
									</p>
								</div>
								<div>
									<a href="https://compoundcoffee.com/" target="_blank" rel="noreferrer">
										<Img fluid={data.compoundCoffee.childImageSharp.fluid} className="merchant-image"/>	
									</a>
								</div>
							</div>
						</div>
						<div className="col-md-4 col-lg-4 col-sm-12 testimonial">
							<p className="font-regular">
									"There has been an increase in the number of purchases via
									Scan QR and Pay. And it's absolutely wonderful, because I don't have to pay the
									exorbitant prices of Stripe.”
							</p>
							<div className="testimonial-author">
								<div  className="testimonial-name">
									<p>
										<b>
											Heetesh Alwani
										</b> <br/> 
										Brewlegger at <a href="https://binjaibrew.com/" target="_blank" rel="noreferrer">Binjai Brew</a>
									</p>
								</div>
								<div>
									<a href="https://binjaibrew.com/" target="_blank" rel="noreferrer">
										<Img fluid={data.binjaiBrew.childImageSharp.fluid} className="merchant-image"/>
									</a>
								</div>
							</div>
						</div>
						<div className="col-md-4 col-lg-4 col-sm-12 testimonial">
							<p className="font-regular">
									"I find maesh very easy to use and very stable. 
									It really solves my manual matching problem. 
									Michael from Maesh is very helpful and get my refund request solved within 2 mins!”
							</p>
							<div className="testimonial-author">
								<div  className="testimonial-name">
									<p>
										<b>
											Chong Hui Teng
										</b> <br/> 
										Founder & Director at <a href="https://gopasarnow.com/" target="_blank" rel="noreferrer">GoPasar</a>
									</p>
								</div>
								<div>
									<a href="https://gopasarnow.com/" target="_blank" rel="noreferrer">
										<Img fluid={data.goPasar.childImageSharp.fluid} className="merchant-image"/>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		
			<section id="faq">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<h1 className="comparison-header text-center">
								Still got questions?
							</h1>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<p className="faq">
								<a href="https://maesh.io/docs/faq">Check out our FAQ &nbsp; <FontAwesomeIcon style={{fontSize:'1rem'}} icon={faAngleRight} />  </a>
							</p>
						</div>
					</div>
				</div>
			</section>
			</div>
		  )}
		  />
      );
    }
}

export default Landing;
